export class AIAssistantManager {
    constructor(aIAssistantService, protocolIngestionService) {
        this.aIAssistantService = aIAssistantService;
        this.protocolIngestionService = protocolIngestionService;
    }
    async call(query, conversationId, callbacks) {
        return await this.aIAssistantService.call(query, conversationId, callbacks);
    }
    async getConversations() {
        return await this.aIAssistantService.getConversations();
    }
    async createConversation(title) {
        return await this.aIAssistantService.createConversation(title);
    }
    async getConversationMessages(conversationId) {
        var _a;
        const messages = (_a = (await this.aIAssistantService.getConversationMessages(conversationId))) !== null && _a !== void 0 ? _a : [];
        return messages.reverse().map((msg) => ({
            ...msg,
            status: "completed",
            metadata: msg.metadata
                ? {
                    ...msg.metadata,
                    noToolsUsed: msg.metadata.toolsUsed.length === 0,
                    footer: {
                        text: this.getFooterText(msg.metadata),
                        type: msg.metadata.toolsUsed.length === 0 ? "warning" : "success",
                    },
                }
                : undefined,
        }));
    }
    async renameConversation(conversationId, title) {
        return await this.aIAssistantService.renameConversation(conversationId, title);
    }
    async deleteConversation(conversationId) {
        return await this.aIAssistantService.deleteConversation(conversationId);
    }
    parseS3Url(s3Url) {
        const withoutProtocol = s3Url.replace("s3://", "");
        const [_, ...pathParts] = withoutProtocol.split("/");
        const path = pathParts.join("/");
        const parts = path.split("/");
        const orgId = parts[1];
        const studyId = parts[3];
        const fileName = parts[5];
        if (!orgId || !studyId || !fileName) {
            console.error("Invalid URL format:", s3Url);
            return null;
        }
        const cleanFileName = fileName.replace(/-\d+$/, "");
        return { orgId, studyId, fileName, cleanFileName };
    }
    async getStudyProtocolDocumentDownloadUrl(s3Url, inline) {
        const parsed = this.parseS3Url(s3Url);
        if (!parsed)
            return null;
        const fileUploadInfo = await this.protocolIngestionService.getStudyProtocolDownloadUrl(parsed.orgId, parsed.studyId, parsed.fileName, inline);
        return {
            signedUrl: fileUploadInfo.signedUrl,
            fileName: parsed.cleanFileName,
        };
    }
    async getICFFormDownloadUrl(s3Url, inline) {
        const parsed = this.parseS3Url(s3Url);
        if (!parsed)
            return null;
        const fileUploadInfo = await this.protocolIngestionService.getICFFormDownloadUrl(parsed.orgId, parsed.studyId, parsed.fileName, inline);
        return {
            signedUrl: fileUploadInfo.signedUrl,
            fileName: parsed.cleanFileName,
        };
    }
    getFooterText(metadata) {
        if (metadata.toolsUsed.length === 0) {
            return "Response generated using the AI assistant context";
        }
        if (metadata.usedKnowledgeBase && metadata.toolsUsed.length > 1) {
            return "Response generated using HealthEx APIs and uploaded protocol documents";
        }
        if (metadata.usedKnowledgeBase) {
            return "Response generated using the uploaded protocol documents";
        }
        return "Response generated using the HealthEx APIs";
    }
}
